import { render } from "./MarkerDemoVideo.vue?vue&type=template&id=985da216"
import script from "./MarkerDemoVideo.vue?vue&type=script&lang=js"
export * from "./MarkerDemoVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__